import Swal from 'sweetalert2';
import { RemoteConstants } from '../../data/remote/RemoteConstants';
import { pinList } from './pinList';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { errorManager } from '../../presentation/utils/errorManager';

/* eslint-disable no-unused-vars */
export const reiniciaIntentos = async (token, usuario, dispatch) => {
    try {
        const params = new URLSearchParams({
            token: token,
            uid: usuario
        });
        const peticion = await fetch(`${RemoteConstants.BASE_URL}pin//reinicia-intentos?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(resp => {
                return resp.json();
            })
            .then(data => {
                if (data.code === 'OK') {
                    Swal.fire('¡Hecho!', data.userMessage, 'success');
                    pinList(token, dispatch);
                } else {
                    errorManager(data.userMessage);
                }
            });
    } catch (error) {
        errorManager(error);
    }
    dispatch(UIActions.uiLoadInactive());
}